<template>
  <div :class="{ border_bottom1px: borderBottom }">
    <van-field v-model="text" :placeholder="placeholder" @blur="blur" />
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "您的真实姓名"
    },
    borderBottom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: ""
    };
  },
  methods: {
    blur() {
      this.$emit("inputValue", this.text);
    }
  }
};
</script>
<style lang="less" scoped>
.input_mes {
  background: #fff;
}
::v-deep .van-field__body {
  font-size: 12px !important;
}
</style>
